<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <core-card [actions]="[]">
      <div class="card-title w-100">
        <div [ngClass.xl]="'float-left'" [ngClass.sm]="'mb-075'" [ngClass.md]="'mb-075'">
          <input type="search" id="datatable-search-input" [placeholder]="'SEARCH' | translate" class="form-control" [(ngModel)]="searchKeyword" (ngModelChange)="paymentMeasureUnitFilter()" />
        </div>
        <div class="float-right">
          <div [ngClass.xl]="'d-inline-block mr-2'" [ngClass.sm]="'d-none'" [ngClass.md]="'d-none'">
            <label class="d-flex align-items-center"
              >{{ "SHOW" | translate }}
              <select class="form-control ml-075 pr-3" (change)="updateTableLimit($event)">
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </label>
          </div>
          <a class="btn btn-outline-primary text-primary" (click)="modalOpen(modalPaymentMeasureUnitAdd, null)" *ngIf="_authenticationService.hasCapability('create_payment_measure_unit')">{{ "ADD" | translate }}</a>
        </div>
        <div class="clearboth"></div>
      </div>
      <div class="card-body px-0 pb-0">
        <ngx-datatable
          class="bootstrap core-bootstrap"
          columnMode="force"
          [headerHeight]="30"
          [scrollbarH]="true"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          [rowHeight]="_utilService.isDesktop ? 50 : 100"
          [limit]="tableLimit"
          [footerHeight]="50"
          [rows]="filteredPaymentMeasureUnitList"
        >
          <ngx-datatable-column [name]="'NAME' | translate" prop="name" width="700" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.name }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'ACTIONS' | translate }}" [sortable]="false" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div>
                <button class="bg-transparent border-0 text-secondary pr-1" (click)="modalOpen(modalPaymentMeasureUnitEdit, row)" *ngIf="_authenticationService.hasCapability('edit_payment_measure_unit')">
                  <i [data-feather]="'edit-2'" size="19"></i>
                </button>
                <button (click)="deletePaymentMeasureUnit(row)" class="bg-transparent border-0 text-danger remove-item" *ngIf="_authenticationService.hasCapability('delete_payment_measure_unit')">
                  <i [data-feather]="'trash-2'" size="19"></i>
                </button>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <!--mobile - tablet-->
          <ngx-datatable-column [name]="'NAME' | translate" prop="name" width="700" [sortable]="true" *ngIf="!_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="row list-item-mobile">
                <div class="col-12 d-flex align-items-center justify-content-between">
                  <span>{{ row.name }}</span>
                  <div>
                    <button class="bg-transparent border-0 text-secondary pr-1" *ngIf="_authenticationService.hasCapability('edit_payment_measure_unit')" (click)="modalOpen(modalPaymentMeasureUnitEdit, row)">
                      <i [data-feather]="'edit-2'" size="19"></i>
                    </button>
                    <button (click)="deletePaymentMeasureUnit(row)" class="bg-transparent border-0 text-danger remove-item" *ngIf="_authenticationService.hasCapability('delete_payment_measure_unit')">
                      <i [data-feather]="'trash-2'" size="19"></i>
                    </button>
                  </div>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </core-card>
  </div>
</div>

<!-- Modal Edit -->
<ng-template #modalPaymentMeasureUnitEdit let-modal>
  <div class="modal-header">
    <div></div>
    <button type="button" class="close" (click)="modal.close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0">
    <h3>{{ "EDIT" | translate }} {{ "PAYMENT_MEASURE_UNIT" | translate }}</h3>
    <div class="row">
      <div class="form-group col-12">
        <label [for]="'name'">{{ "PAYMENT_MEASURE_UNIT" | translate }}<sup class="text-danger">*</sup></label>
        <input name="name" [(ngModel)]="paymentMeasureUnit.name" type="text" [id]="'name'" class="form-control" />
        <div class="font-error" *ngIf="showModalError && (!paymentMeasureUnit.name || paymentMeasureUnit.name.length < 1 || paymentMeasureUnit.name.trim() === '')">
          {{ "ERRORS.INSERT_PAYMENT_MEASURE_UNIT" | translate }}
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close()" rippleEffect>
      {{ "ALERT.BTN_CANCEL" | translate }}
    </button>
    <button type="submit" class="btn btn-primary w-150" rippleEffect (click)="editPaymentMeasureUnit()">
      {{ "EDIT" | translate }}
    </button>
  </div>
</ng-template>
<!-- / Modal Edit -->

<!-- Modal Add -->
<ng-template #modalPaymentMeasureUnitAdd let-modal>
  <div class="modal-header">
    <div></div>
    <button type="button" class="close" (click)="modal.close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0">
    <h3>{{ "ADD" | translate }} {{ "PAYMENT_MEASURE_UNIT" | translate }}</h3>
    <div class="row">
      <div class="form-group col-12">
        <label [for]="'name'">{{ "PAYMENT_MEASURE_UNIT" | translate }}<sup class="text-danger">*</sup></label>
        <input name="name" [(ngModel)]="paymentMeasureUnit.name" type="text" [id]="'name'" class="form-control" />
        <div class="font-error" *ngIf="showModalError && (!paymentMeasureUnit.name || paymentMeasureUnit.name.length < 1 || paymentMeasureUnit.name.trim() === '')">
          {{ "ERRORS.INSERT_PAYMENT_MEASURE_UNIT" | translate }}
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close()" rippleEffect>
      {{ "ALERT.BTN_CANCEL" | translate }}
    </button>
    <button type="submit" class="btn btn-primary w-150" rippleEffect (click)="addPaymentMeasureUnit()">{{ "SEND" | translate }}/{{ "ERRORS.INSERT" | translate }}</button>
  </div>
</ng-template>
<!-- / Modal Add -->
